<div class="modal" id="cityModal" tabindex="-1">
	<div class="modal-dialog modal-lg">
		<div class="modal-content">
			<div class="modal-header">
				<h3>
					{{ service.citySelected?.name }}
					<div class="btn btn-link btn-sm" data-bs-dismiss="modal" (click)="cruising()">Przejazd przez</div>
				</h3>
				<h3 class="d-flex">
					{{ service.vehicleSelected?.name }}
				</h3>
			</div>
			<div class="modal-body">
				<div class="row">
					<div class="col-6">
						<div class="d-grid mb-2">
							<div
								class="btn btn-primary"
								data-bs-dismiss="modal"
								*ngIf="service.editable && service.citySelected?.destinations.length"
								(click)="service.boardingAll()"
							>
								Zabierz wszystkich <i class="fas fa-angle-double-right"></i>
							</div>
						</div>
						<table class="table table-bordered align-middle">
							<thead>
								<tr>
									<th>Program</th>
									<th>Żródło</th>
									<th>Zabierz</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let cityItem of service.citySelected?.destinations">
									<td>{{ cityItem.name }}</td>
									<td>{{ cityItem.from }}</td>
									<td class="text-center">
										<div
											class="btn btn-primary"
											(click)="boarding(cityItem)"
											*ngIf="service.editable"
										>
											<i class="fas fa-chevron-right"></i>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="col-6">
						<div class="d-grid mb-2">
							<div
								type="button"
								class="btn btn-primary"
								data-bs-dismiss="modal"
								*ngIf="service.editable && service.vehicleSelected?.destinations?.length"
								(click)="service.dropoffAll()"
							>
								<i class="fas fa-angle-double-left"></i> Zostaw wszystkich
							</div>
						</div>
						<table class="table table-bordered align-middle">
							<thead>
								<tr>
									<th>Zostaw</th>
									<th>Program</th>
									<th>Żródło</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let vehicleItem of service.vehicleSelected?.destinations">
									<td class="text-center">
										<div
											class="btn btn-primary"
											(click)="dropoff(vehicleItem)"
											*ngIf="service.editable"
										>
											<i class="fas fa-chevron-left"></i>
										</div>
									</td>
									<td>{{ vehicleItem.name }}</td>
									<td>{{ vehicleItem.from }}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Zamknij</button>
			</div>
		</div>
	</div>
</div>
